import workspaceQuery from '../../../graphql/queries/sales/MagentoConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/MagentoConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/MagentoConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/MagentoConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/MagentoConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/MagentoConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const MagentoConfiguration: EntityType = {
  type: 'MagentoConfiguration',
  title: 'Magento Configurations',
  formTitle: 'Magento Configuration',
  formUrl: '/Sales/Channel/MagentoConfig/Details/',
  workspaceUrl: '/Sales/Channel/MagentoConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_MAGENTO_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default MagentoConfiguration;
